import { faFile, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WebViewTexts } from '../../../language/Texts';
import { ComponentType } from '../../../models/componentType.enum';
import DropzoneComp from '../dropzone/DropzoneComp';
import './DocumentComponent.scss';

interface DocumentComponentProps {
    files: File[] | undefined,
    setFiles: (files) => void;
    type?: ComponentType;
}

function DocumentComponent({ files, setFiles, type }: DocumentComponentProps) {

    const handleFileLoaded = (file: File) => {
        setFiles((prevFiles) => [...prevFiles, file]);
    };

    const handleRemoveFile = (index: number) => {
        if (files && index >= 0 && index < files.length) {
            const updatedFiles = [...files];
            updatedFiles.splice(index, 1);
            setFiles(updatedFiles);
        }
    };

    return (
        <div
            className={`form_document_wrapper ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_form_document_wrapper' : 'form_document_wrapper'}`}
        >
            <div className={`input_label ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_label' : ''}`}>{WebViewTexts.documents}</div>
            <DropzoneComp onFileLoaded={handleFileLoaded} type={type} />

            {files?.map((file, index) => (
                <div className='single_document_group' key={index}>
                    <div className="document_icon_name">
                        <FontAwesomeIcon className="form_file_icon" icon={faFile} />
                        <div className="form_document_info">  {file.name}</div>
                    </div>
                    <button type="button" className="icon_wrapper_1 remove_icon_wrapper" onClick={() => handleRemoveFile(index)}>
                        <span className="icon_wrapper_2"                >
                            <FontAwesomeIcon icon={faMinus} className="add_remove_icon" />
                        </span>
                    </button>
                </div>
            ))}
        </div>
    )
}

export default DocumentComponent
